import { render, staticRenderFns } from "./CarroUpdate.vue?vue&type=template&id=f401e840&"
import script from "./CarroUpdate.vue?vue&type=script&lang=js&"
export * from "./CarroUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports